import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMagnifyingGlassHandDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M26.5 95C26.5 94.5 27.3 94.2 26.5 93C25.5 91.5 15.9417 79.9755 15.5 76C15 71.5 16.5 66 23 65M23 65C28.2 64.2 31.1667 66.8333 32.5 68M23 65C21.8333 62.5 24.9 56.5 30.5 56.5M30.5 56.5C36.1 56.5 39.1667 58.8333 40 60M30.5 56.5C30.5 54.1666 32.5046 50.4439 36.5 50C41 49.5 45.5 53.8333 47.5 55.5",
			stroke: "white",
			strokeOpacity: .24
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23 74C23.3215 74.4969 24.4796 75.8167 25 76.5M36 75.5C36 75.5 40.5 83 38.5 84C36.5 85 33.5 84 32 83C29.5147 81.3432 27.4471 79.7129 25 76.5M25 76.5L25.5 73.5",
			stroke: "white",
			strokeOpacity: .24,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M75 60C78.1667 59.1667 86.3232 59.3687 85 64C84 67.5 81.5 67 81.5 65C81.5 61.4645 83.5 56 87 57C90.5 58 92.5 61.125 91 61.5C89 62 86 57 90 55.5C93.2 54.3 94.6667 54 95 54",
			stroke: "white",
			strokeOpacity: .24,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35 29.5L27 30.5",
			stroke: "white",
			strokeOpacity: .24,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M35 19C34.2 18.6 29 16.1667 26.5 15",
			stroke: "white",
			strokeOpacity: .24,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.5 8L32 2",
			stroke: "white",
			strokeOpacity: .24,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 68,
			cy: 27,
			r: 25.5,
			stroke: "#8588D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68 1.5C82.0925 1.5 93.5 12.702 93.5 26.5C93.5 40.298 82.0925 51.5 68 51.5C53.9075 51.5 42.5 40.298 42.5 26.5C42.5 12.702 53.9075 1.5 68 1.5Z",
			stroke: "#8588D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.9122 86.1309L14.8751 91.8311C14.6923 92.0379 14.3759 92.0577 14.169 91.875C13.9622 91.6922 13.9424 91.3759 14.1251 91.169L19.0255 85.6231L19.9122 86.1309ZM52.1993 48.1006C52.3851 47.9604 52.6499 47.9651 52.8311 48.125C53.0122 48.2851 53.0498 48.5474 52.9337 48.7491L52.8751 48.8311L48.713 53.5401L47.8262 53.0323L52.1251 48.169L52.1993 48.1006Z",
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 67,
			cy: 12,
			r: 6,
			fill: "#8588D8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49 15.5C50.8333 17 54.8 19.2 58 20C62 21 59.7414 27.6896 58.5 31C57 35 49.6667 29.3333 45.5 27",
			stroke: "white",
			strokeOpacity: .24,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M79 45.5C78.5 45.5 69.5 41.5 69 42C68.5 42.5 66 48 67 48.5C67.8 48.9 68.6667 49 69 49",
			stroke: "white",
			strokeOpacity: .24,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M90 24.5C88.5 24 81 18.5 79 20.5C77 22.5 76.5 28.5 77 30C77.4 31.2 84.8333 33.5 88.5 34.5",
			stroke: "white",
			strokeOpacity: .24,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 95,
			width: 96,
			height: 1,
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5 83.5L25 79.5",
			stroke: "white",
			strokeOpacity: .24
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M48.5 91C49.5 88.5 58.5 89 58.5 89L60.5 95H27L27.0537 94.8809C27.0981 94.7978 27.2046 94.6189 27.2715 94.4268C27.3464 94.2114 27.384 93.9578 27.3291 93.6583C27.2908 93.4493 27.2098 93.2323 27.084 93.001C28.5064 93.0323 47.5367 93.4064 48.5 91Z",
			fill: "white",
			fillOpacity: .24
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.6064 54.934C50.2019 53.9851 52.9075 53.716 55.2236 55.0521L55.5195 55.2074C56.9847 56.0056 58.2169 57.1971 58.9677 59.1986C59.758 61.3062 60.0001 64.2736 59.496 68.558C59.2804 70.3902 58.2857 72.8328 57.1044 75.1547C56.5434 76.2575 55.9309 77.3467 55.3271 78.35C55.5278 78.3953 55.7055 78.498 55.8535 78.6459C55.9538 78.7462 56.0404 78.883 56.1123 79.0101C56.1896 79.1471 56.2727 79.3148 56.3593 79.5043C56.5328 79.8838 56.7336 80.3791 56.9531 80.9564C57.3927 82.1131 57.9174 83.6273 58.4619 85.267C59.5513 88.5479 60.7276 92.353 61.4785 94.8559C61.4928 94.9036 61.4979 94.952 61.498 94.9994H60.4765C59.726 92.502 58.5774 88.7888 57.5126 85.5824C56.9697 83.9475 56.4506 82.4488 56.0185 81.3119C55.8022 80.7428 55.6095 80.2701 55.4492 79.9193C55.369 79.7441 55.3001 79.6049 55.2421 79.5023C55.1791 79.3908 55.1465 79.353 55.1464 79.3529C55.1251 79.3317 55.1122 79.3246 55.1074 79.3226C55.1032 79.3224 55.0814 79.3231 55.0361 79.3422C54.9093 79.3956 54.7289 79.5387 54.5097 79.7836C54.3259 79.9891 54.1441 80.2329 53.9726 80.476C53.7865 80.7507 53.6066 81.0108 53.4335 81.2514C53.4216 81.2678 53.4115 81.2853 53.4003 81.3002L52.5947 80.7074L52.5996 80.6996L53.0781 80.0082C53.1006 79.9757 53.1249 79.9429 53.1484 79.9096C54.1139 78.4839 55.2408 76.6141 56.2138 74.7016C57.3884 72.3928 58.3095 70.0845 58.5029 68.4408C58.9987 64.2258 58.7408 61.4425 58.0312 59.5502C57.332 57.686 56.1811 56.6491 54.7763 55.9467L54.7617 55.9398L54.748 55.932L54.4882 55.7894C51.7788 54.3942 48.3244 55.4024 45.0429 57.224C41.7062 59.0765 38.7516 61.6561 37.3398 62.8666C35.0911 65.1164 32.9945 67.4835 32.081 69.4174C31.6215 70.3903 31.5115 71.1502 31.7089 71.7016C31.895 72.2207 32.4154 72.7135 33.621 73.015C35.4476 73.4717 36.8043 73.0289 38.2226 72.0834C38.5769 71.8472 39.2556 71.3121 40.1582 70.6049C41.0496 69.9063 42.1381 69.0571 43.2832 68.2182C44.4273 67.3799 45.6378 66.5453 46.7734 65.8773C47.8974 65.2163 48.9933 64.6909 49.9013 64.5092C51.3976 64.2099 52.4789 64.9774 53.1767 65.7201C53.5257 66.0916 53.7997 66.4776 53.9931 66.7484C54.0948 66.8908 54.1645 66.9865 54.2167 67.0482C54.2184 67.0502 54.2201 67.0523 54.2216 67.0541C54.3858 67.1359 54.4997 67.3036 54.5 67.4994C54.4999 67.7754 54.276 67.9993 54 67.9994C53.8046 67.9993 53.6671 67.8983 53.6162 67.8578C53.5511 67.806 53.4952 67.7445 53.4531 67.6947C53.3682 67.5944 53.2718 67.4599 53.1787 67.3295C52.9816 67.0536 52.7447 66.7204 52.4482 66.4047C51.8543 65.7726 51.101 65.289 50.0976 65.4896C49.3616 65.637 48.3855 66.0896 47.2802 66.7396C46.186 67.3832 45.0068 68.1956 43.875 69.0248C42.7441 69.8533 41.6666 70.6936 40.7753 71.392C39.8959 72.0812 39.1731 72.6515 38.7773 72.9154C37.1958 73.9697 35.5519 74.528 33.3789 73.9848C32.0069 73.6417 31.1118 72.9993 30.7675 72.0385C30.4351 71.1099 30.6795 70.0435 31.1767 68.9906C31.3306 68.6647 31.5149 68.3308 31.7226 67.9896C31.8879 68.1295 32.0383 68.2596 32.1718 68.3764L32.83 67.6244C32.67 67.4844 32.4845 67.3225 32.2744 67.1469C33.4201 65.508 35.0276 63.7648 36.6464 62.1459L36.6601 62.1322L36.6748 62.1205C37.2754 61.6057 38.1825 60.8208 39.2949 59.9389C39.4176 60.0675 39.5185 60.1852 39.5937 60.2904L40.0009 60.0004L40.4072 59.7094C40.3202 59.5876 40.2109 59.4588 40.0849 59.3217C41.3984 58.3201 42.9321 57.2524 44.5576 56.35C45.2057 55.9902 45.8765 55.6531 46.5595 55.3549C46.7846 55.548 46.992 55.727 47.1806 55.8842L47.5009 55.5004L47.8203 55.1166C47.752 55.0597 47.6812 54.9975 47.6064 54.934Z",
			fill: "white",
			fillOpacity: .24
		})
	]
});
export default SvgMagnifyingGlassHandDark;
